import { jsx as a, Fragment as n } from "react/jsx-runtime";
import o from "react";
import { p as e } from "../../index-DB0QlRo7.mjs";
function c({ list: t }) {
  return /* @__PURE__ */ a(n, { children: t.map((r) => /* @__PURE__ */ a(o.Fragment, { children: typeof r == "string" && r !== "" ? e(r) : r }, `react-frag-${Math.round(Math.random() * 1e7)}`)) });
}
export {
  c as Concat,
  c as default
};
